import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-4 bg-gradient-to-r from-danger to-orange px-5 py-2.5 text-center text-[13px] font-bold text-white" data-id="element-306">
      <span data-id="element-307">🔥 FLASH SALE — 95% OFF ends in:</span>
      <div className="flex items-center gap-2" data-id="element-308">
        <div className="min-w-[40px] rounded bg-black/30 px-2.5 py-1 text-center font-mono text-base font-black" data-id="element-309">
          <span data-id="element-310">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="block text-[9px] tracking-[1px] opacity-80" data-id="element-311">
            HRS
          </span>
        </div>
        <span className="text-lg font-black" data-id="element-312">:</span>
        <div className="min-w-[40px] rounded bg-black/30 px-2.5 py-1 text-center font-mono text-base font-black" data-id="element-313">
          <span data-id="element-314">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="block text-[9px] tracking-[1px] opacity-80" data-id="element-315">
            MIN
          </span>
        </div>
        <span className="text-lg font-black" data-id="element-316">:</span>
        <div className="min-w-[40px] rounded bg-black/30 px-2.5 py-1 text-center font-mono text-base font-black" data-id="element-317">
          <span data-id="element-318">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="block text-[9px] tracking-[1px] opacity-80" data-id="element-319">
            SEC
          </span>
        </div>
      </div>
      <span data-id="element-320">
        Get the Bundle for <strong data-id="element-321">$6.97</strong>
      </span>
    </div>;
}